<template>
  <section class="rounded-lg border border-gray-200 px-6 py-4">
    <h3 v-if="title" class="text-xl font-normal">
      {{ title }}
    </h3>
    <slot />
  </section>
</template>
<script lang="ts" setup>
interface IProps {
  title?: string;
}

defineProps<IProps>();
</script>
